export const LOAD_CONTENT = 'mp/upsell/LOAD_CONTENT';

export const loadContent = () => {
  return {
    type: LOAD_CONTENT
  };
};



/** WEBPACK FOOTER **
 ** ./client/redux/modules/pages/MyPlan/upsell/upsell.js
 **/